var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3477_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14757 34.7705H4.74365V37.8132H9.14757V34.7705Z",
    fill: "#114289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8165 34.7705H37.4126V37.8132H41.8165V34.7705Z",
    fill: "#114289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3381 34.6904H2.82207C1.621 34.6904 0.580078 33.7296 0.580078 32.4484V14.4324C0.580078 13.2314 1.54093 12.1904 2.82207 12.1904H43.3381C44.5392 12.1904 45.5801 13.1513 45.5801 14.4324V32.5285C45.5801 33.7296 44.5392 34.6904 43.3381 34.6904Z",
    fill: "url(#paint0_linear_3477_936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5639 31.5674H5.62435C4.6635 31.5674 3.78271 30.7667 3.78271 29.7258V17.2347C3.78271 16.2738 4.58343 15.3931 5.62435 15.3931H27.5639C28.5247 15.3931 29.4055 16.1938 29.4055 17.2347V29.8059C29.4055 30.7667 28.6048 31.5674 27.5639 31.5674Z",
    fill: "#9BC3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7331 27.8045C39.9442 27.8045 41.7366 26.012 41.7366 23.8009C41.7366 21.5898 39.9442 19.7974 37.7331 19.7974C35.5219 19.7974 33.7295 21.5898 33.7295 23.8009C33.7295 26.012 35.5219 27.8045 37.7331 27.8045Z",
    fill: "#9BC3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7332 26.3628C39.1483 26.3628 40.2955 25.2157 40.2955 23.8006C40.2955 22.3855 39.1483 21.2383 37.7332 21.2383C36.3181 21.2383 35.1709 22.3855 35.1709 23.8006C35.1709 25.2157 36.3181 26.3628 37.7332 26.3628Z",
    fill: "#114289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9966 26.5232C18.7564 26.9236 18.5161 27.1638 18.1158 27.4841C17.7154 27.7243 17.235 27.8844 16.6745 27.9645V29.0054H15.8738V27.9645C15.0731 27.8844 14.4325 27.6442 13.9521 27.2438C13.4717 26.8435 13.2314 26.283 13.2314 25.5623H14.7528C14.7528 25.8826 14.9129 26.1228 15.0731 26.3631C15.2332 26.6033 15.5535 26.6833 15.8738 26.7634V24.041C15.3133 23.8808 14.8329 23.7207 14.5126 23.6406C14.1923 23.4805 13.872 23.2403 13.6318 22.92C13.3916 22.5997 13.2314 22.1994 13.2314 21.6389C13.2314 20.9182 13.4717 20.3577 13.9521 19.9574C14.4325 19.557 15.0731 19.2367 15.8738 19.1566V18.1157H16.6745V19.1566C17.3951 19.2367 17.9556 19.4769 18.4361 19.8773C18.9165 20.2776 19.1567 20.8381 19.1567 21.4787H17.6354C17.6354 21.2385 17.4752 20.9983 17.3151 20.7581C17.1549 20.5179 16.9147 20.4378 16.5944 20.3577V22.92C17.1549 23.0801 17.6354 23.1602 17.9556 23.3204C18.2759 23.4805 18.5962 23.7207 18.8364 24.041C19.0766 24.3613 19.2368 24.7616 19.2368 25.3221C19.2368 25.8026 19.1567 26.1228 18.9966 26.5232ZM14.993 22.2794C15.2332 22.4396 15.4734 22.5997 15.8738 22.7599V20.2776C15.5535 20.3577 15.2332 20.4378 14.993 20.678C14.7528 20.9182 14.6727 21.1584 14.6727 21.5588C14.6727 21.799 14.7528 22.1193 14.993 22.2794ZM17.5553 26.283C17.7955 26.0428 17.8756 25.7225 17.8756 25.4022C17.8756 25.0819 17.7955 24.8417 17.5553 24.6015C17.3151 24.4413 17.0749 24.2812 16.6745 24.1211V26.6833C16.9948 26.6833 17.3151 26.5232 17.5553 26.283Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3477_936",
    x1: 23.0801,
    y1: 12.1904,
    x2: 23.0801,
    y2: 34.6904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056BED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3477_936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.0801,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBank);
export default __webpack_public_path__ + "static/media/admin_bank.4c0310458f789e55d480633062629a18.svg";
export { ForwardRef as ReactComponent };